import { render, staticRenderFns } from "./text_generate2.vue?vue&type=template&id=b7cfe670&scoped=true"
import script from "./text_generate2.vue?vue&type=script&lang=js"
export * from "./text_generate2.vue?vue&type=script&lang=js"
import style0 from "./text_generate2.vue?vue&type=style&index=0&id=b7cfe670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cfe670",
  null
  
)

export default component.exports